import React from "react";
import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";
import { Card } from "@rentablo/components";

const CardStyled = styled(Card)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  background-color: ${({ theme }) => theme.palette.background.subtle};
  box-shadow: none;
  display: flex;
  box-sizing: border-box;
  border: none;
`;

export const NewsItemSkeleton = () => (
  <CardStyled size="row">
    <Skeleton width={128} height={8} />
    <Skeleton width={32} height={8} />
  </CardStyled>
);
